module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"qa":"常见问题？"},"en":{"qa":"Q&A"}}')
  delete Component.options._Ctor
}
